<template>
  <div class="index">
    <div class="wrap-img"></div>
    <div class="header">
      <div class="title">人才盘点</div>
      <div class="desc">个人职业倾向测评，匹配合适的岗位，帮助测评者正确认识自己的优势、长处，选择合适与喜欢的岗位胜任模型，实现人岗匹配的高质量就业意向</div>
    </div>

    <div class="content"></div>

    <div class="footer">
      <vant-button round block color="#315ace" @click="toStart">开始测评</vant-button>
    </div>
  </div>
</template>
<script>
import { getProjectInfo, getReportInfo } from "@api/eval";
import { mapGetters } from "vuex";
import { Button as VantButton } from "vant";



export default {
  name: "Index",
  computed:{
    ...mapGetters(['token'])
  },
  components: {
    VantButton
  },
  props: {},
  data: function() {
    return {
      projectId : this.$route.params.projectId,
      report: null
    };
  },
  mounted: function() {
    getReportInfo(this.projectId).then(res => {
      this.report = res.result
    });
  },
  methods: {
    toStart() {
      this.$router.push({ path: `/eval/register` });
    }
  }
};
</script>
<style lang="scss" scoped>
.index {
  background-color: #f5f5f5;
  min-height: 100vh;
  .wrap-img {
    height: 180px;
    background: url("~@images/bg_sign_up.jpg") 0 0 no-repeat;
    background-size: cover;
  }

  .header{
    padding:10px 20px;
    background-color: #FFFFFF;
    .title{
      font-size: 18px;
      color:#333333;
      line-height: 30px;
      font-weight: bold;
    }
    .desc{
      font-size: 14px;
      line-height: 25px;
      color: #7d7d7d;
    }

  }

  .content{
    min-height: 200px;
    background-color: #FFFFFF;
    padding: 10px 15px;
    margin-top: 8px;
  }

  .footer{
    position: fixed;
    right: 0;
    left: 0;
    bottom: 0;
    padding: 10px 30px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }
}
</style>
